import { ZealApiResponse } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TSubmitWorkerPaycardSocialSecurityCardVerification } from "./submitWorkerPaycardSocialSecurityCardVerification.schema";

export const submitWorkerPaycardSocialSecurityCardVerification = (
  axios: IAxiosInstance
) => {
  return async (body: TSubmitWorkerPaycardSocialSecurityCardVerification) => {
    const response = await axios.noRetry.post<ZealApiResponse<boolean>>(
      "/api/submitWorkerPaycardSocialSecurityCardVerification",
      body
    );

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
